import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {login} from "../../redux/actions/userAction"
import { Navigate } from 'react-router-dom'

const Login = () => {

  const dispatch = useDispatch()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [errorMessage,setErrorMessage]=useState("")
  const {isAuthenticated, loading} = useSelector(state=>state.user)

  const handleSubmit = () => {
    if(email.trim().length===0 || password.trim().length===0){
      setErrorMessage("Please fill all the fields")
    } else if (!emailValidation()) {
      setErrorMessage("Please enter a valid email")
    } else {
      dispatch(login(email, password))
      .then(res=>{
        if (!res.success) {
          setErrorMessage(res.message)
        } else {
          const user = {name: res.user.name, email: res.user.email, id: res.user._id}
          localStorage.setItem("user", JSON.stringify(user))
          localStorage.setItem("token", res.token)
        }
      })
    }
  }

  const emailValidation = () => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  }

  useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        document.getElementById("submitBtn").click()
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [])

  return (
    !isAuthenticated ?  <section className='d-flex align-items-center justify-content-center min-vh-100'>
        <div className='px-8 px-lg-0' style={{maxWidth:"450px"}}>
            <div className="row">
                <img src="/assets/img/logo.png" alt="" />
                <p className='w-100 mt-5'>Please sign in</p>
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
                <input type="email" name='email' className='form-control' placeholder='Email Address' autoComplete='off' value={email} onChange={(e)=>setEmail(e.target.value)} tabIndex={1}/>
                <p className="text-end mb-0 mt-5 ml-auto"><a className='text-secondary' href="/forgotpassword">Forgot Password?</a></p>
                <input type="password" name='password' className='form-control' placeholder='Password' value={password} onChange={(e)=>setPassword(e.target.value) } tabIndex={2}/>
                <button className='mt-5 btn btn-primary w-100' onClick={handleSubmit} tabIndex={3}>{loading ? <div className="spinner-border loader-sizing" style={{height:"1.5rem", width:"1.5rem"}} role="status"><span className="sr-only"></span></div>:'Sign in'}</button>
                <p className='mt-5 text-center w-100 text-secondary'>Don't have an account? <a className='text-primary' href="/register">Sign up</a></p>
            </div>
        </div>
    </section> : <Navigate to={'/'} />
  )
}

export default Login